module.exports = __webpack_public_path__ + "img/21_93.4692c5d3.png";